export default [
  {
    name: 'Door Restoration',
    slug: 'door-restoration',
    imgSrc: '/images/Door%20restoration.png',
    imgAltText: 'A freshly painted door',
    matchImageHeight: true,
    imagePosition: 'center',
    intro: 'We offer a unique service to restore your original doors:',
    bullets: [
      'New doors off the shelf can be very expensive and do not always have that authentic feel or look.',
      'Our sister company, Sash Window Preservation, can provide you with a bespoke handmade one-off door to match your original. They will fit the door, draught proof it and supply all new hardware.',
      'We can, however, restore any door if it is not beyond repair. The process often requires removing the door and stripping back all the layers of paint to reveal the natural timber.',
      'Once the door has been removed, we can repair old timber using traditional methods and paint the door, even upgrading with new locks and hinges to meet insurance requirements.',
      'You can handpick from a choice of any colour to suit your property. We can personally advise you on colours to help transform the look of your house, or keep with the original colours if the property is listed and needs to retain its period appearance.'
    ]
  },
  {
    name: 'Window Restoration',
    slug: 'window-restoration',
    imgSrc: '/images/Window%20restoration.jpg',
    imgAltText: 'A restored sash window',
    matchImageHeight: true,
    intro: 'Once your new windows or doors have been fitted, we can carry out all necessary painting on site:',
    bullets: [
      'If the new joinery has already been pre-painted, we can paint the box sash frames or door frames on site.',
      'If your windows or doors have been draught-proofed, or if double glazing has been fitted into the existing frames, we can complete all painting on site.',
      'Our process involves extensive preparation, including stripping back old, tired paintwork.',
      'Original timber is often covered with multiple layers of different paints. We carefully strip and sand it back to reveal the timber beneath before applying layers of modern, protective paint designed to preserve it for years to come.',
      'You can choose from a wide range of colours and shades of white. We are always happy to offer expert advice to help you achieve the best finish and give your property a fresh new look.'
    ]
  },
  {
    name: 'Interior Design',
    slug: 'interior-design',
    imgSrc: '/images/Interior%20design.png',
    imgAltText: 'A freshly painted interior room',
    intro: 'We also specialise in interior painting, helping you redesign any room in your house:',
    bullets: [
      'Having worked in some of the most beautiful properties across the U.K., I often find inspiration in all of the houses I have visited.',
      'We understand our customers\' needs and offer a one-to-one consultation, where we explore new ideas for a room, perhaps adding colours that bring out the natural light which can change throughout the day, bringing different tones. This often lifts a dull room, bringing it into the 21st century; not spoiling the original features but accentuating them to bring out the architectural highlights of the room.'
    ]
  },
  {
    name: 'Preparation is Key',
    slug: 'extensive-preparation',
    imgSrc: '/images/Preparation.png',
    imgAltText: 'Careful preparation work in a period property',
    intro: 'Having worked in historic buildings over many years, we have mastered the art of preparation:',
    bullets: [
      'We understand our customers\' individual needs - whether it be your Chesterfield sofa or a framed piece of art, we always take every precaution to be sensitive to your home and fabrics.',
      'We can move furniture and assist with curtains - if you need help we are always on hand to deliver a great experience for our customers.'
    ]
  },
  {
    name: 'Pre-Painting',
    slug: 'pre-painting',
    imgSrc: '/images/Pre-painting.png',
    imgAltText: 'Workshop pre-painting of windows and doors',
    matchImageHeight: true,
    intro: 'We offer a bespoke service to have your windows or doors pre-painted in our workshop:',
    bullets: [
      'We can paint the window in a colour of your choice along with a finish of your preference.',
      'We use only the best possible products on the market, ensuring that your new paint will last for many years.',
      'On period properties our customers often use paints from the Farrow &amp; Ball colour range, or paint from other manufacturers such as Little Greene. To order free Colour Cards created using real Farrow &amp; Ball paint chips visit:<br><a href="https://www.farrow-ball.com/paint/colour-cards" target="_blank" rel="noopener noreferrer" class="underline">farrow-ball.com/paint/colour-cards</a> or to buy paint sample pots visit: <a href="https://www.littlegreene.com/paint/sample-pots" target="_blank" rel="noopener noreferrer" class="underline">littlegreene.com/paint/sample-pots</a>',
      'We can match any colour regardless of manufacturer or brand of paint.',
      'As timber tends to move with the changes in the seasons, our preference is to use traditional oil-based paints, which show the best results due to its flexibility',
      'Once the new joinery has been hand painted to the highest possible standard, it will be quality controlled and checked before it leaves our workshop, and delivered to site in time for the first day of work commencing. All the new timber is individually hand-wrapped and signed off by one of our specialist painters, ensuring the quality and consistency of the high-end product you have purchased.'
    ]
  },
  {
    name: 'Shutter Restoration',
    slug: 'shutter-restoration',
    imgSrc: '/images/Shutter%20restoration.png',
    imgAltText: 'Restored interior shutters',
    matchImageHeight: true,
    imagePosition: 'top',
    intro: 'We offer a service that can transform your home:',
    bullets: [
      'Original shutters are often completely forgotten and remain painted in place and unused.',
      'Shutters were originally designed to stop light and cold air passing though the windows.',
      'We can return them to fully operational for you, often taking them back to our workshop where great care and attention is taken to slowly remove years of overpainting to reveal the moulding and panelling. Paint is then carefully reapplied prior to refitting, leaving you with fresh operational shutters that both work as originally intended and accentuate the appearance of your sash windows.',
      'We can match any existing colour or even advise you on other tones which can give you a more contemporary look to really lift the room.'
    ]
  },
  {
    name: 'Exterior Masonry',
    slug: 'exterior-masonry',
    imgSrc: '/images/Exterior%20masonry.png',
    imgAltText: 'A property with freshly painted exterior masonry',
    intro: 'On period properties, there are often many decorative masonry areas:',
    bullets: [
      'Cracks appear over time above the windows or doors due to movement in the property.',
      'Weather has an impact too and can wear away the material. If it needs repairing we can do this using traditional methods which retain the style and have it repainted, safe and watertight for many years to come.'
    ]
  },
  {
    name: 'Scaffolding',
    slug: 'scaffolding',
    imgSrc: '/images/Scaffolding.png',
    imgAltText: 'Scaffolding set up for exterior painting',
    matchImageHeight: true,
    intro: 'We can arrange scaffolding for you if required:',
    bullets: [
      'On some projects, scaffolding may be needed to access areas such as fascia boards or other high-level sections that are too difficult or unsafe to reach with ladders.',
      'Cherry pickers can also be used for particularly hard-to-reach areas.',
      'With many years of experience fitting sash windows, we are often able to remove and carefully rotate windows in situ, which can help avoid unnecessary scaffolding costs.',
      'This is especially useful in places such as London, where scaffolding can be expensive and permits are often required. In many cases, we can remove and refit the windows at no extra cost.'
    ]
  },
  {
    name: 'Timber Conservation',
    slug: 'timber-conservation',
    imgSrc: '/images/timber1.jpg',
    imgAltText: 'Conserved timber on a period property',
    bullets: [
      'Where the original timber is still in good condition and does not need replacing due to rot, we use traditional repair methods to preserve and protect it.',
      'This is particularly important for period and listed buildings, where maintaining as much original material as possible is essential.'
    ]
  },
  {
    name: 'Areas We Cover',
    slug: 'areas-we-cover',
    imgSrc: '/images/lighthouse.jpg',
    imgAltText: 'A lighthouse — one of the areas we cover',
    imagePosition: 'center 70%',
    matchImageHeight: true,
    intro: 'You may be surprised by how many places we have worked over the years:',
    bullets: [
      'We work across the South of England, from coast to coast.',
      'Our projects range from the beautiful towns and villages of North Norfolk to coastal locations such as Brighton.',
      'We have also completed many projects in London, Cambridge, Ipswich, Oxford and Colchester.',
      'Much of our work comes through recommendation, and in areas such as Southwold we have spent many long days restoring buildings to their former beauty.',
      'No location is too far for us. As specialists in historic buildings, we work to the highest standard and always take great care to respect the character of your property.',
      'Maintaining the upkeep of your building is essential, and we are here to help you do that properly.'
    ]
  }
]



// WEBPACK FOOTER //
// ./src/lib/services.js